interface IFormatPriceOptions {
  fractionDigits?: number;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  currencyCode?: string;
  compactDisplay?: 'short' | 'long';
  notation?: 'standard' | 'scientific' | 'engineering' | 'compact';
}

export default function formatPrice(
  val: string | number,
  {
    fractionDigits,
    minimumFractionDigits,
    maximumFractionDigits,
    currencyCode,
    compactDisplay,
    notation,
  }: IFormatPriceOptions = {
    fractionDigits: 2,
    notation: 'standard',
    compactDisplay: 'long',
  }
): string {
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode || 'USD',
    minimumFractionDigits: minimumFractionDigits || fractionDigits,
    maximumFractionDigits: maximumFractionDigits || fractionDigits,
    compactDisplay,
    notation,
  }).format(Number(val));
}
